import React from "react";
import styles from "./ctahome.module.css";
import { MdCall } from "react-icons/md";

const CTAHome = () => {
  const phoneNumber = "+919365484564";

  return (
    <div className={styles.ctaSection}>
      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <h2 className={styles.title}>
          Escape to the Wild, Reconnect with Nature
        </h2>

        <p className={styles.subtitle}>
          Tents &bull; Campfires &bull; Adventures Await
        </p>

        <a href={`tel:${phoneNumber}`} className={styles.buttonWrapper}>
          <button className={styles.ctaButton}>
            <MdCall size={20} className={styles.phoneIcon} />
            <span>Call Us at {phoneNumber}</span>
          </button>
        </a>
      </div>
    </div>
  );
};

export default CTAHome;